import { NotificationModel } from '@aionzdev/modules';
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';

import { SKIP_HTTP_CACHE } from '../../interceptors/skip-http-cache';
import { NOTIFICATION_DOMAINS, NotificationDomain } from '../notification-domains';

export interface NotificationResource {
  type: string;
  id: number;
}

export interface AlertNotification {
  _id: string;
  domain?: NotificationDomain;
  resource?: NotificationResource;
  title: string;
  type: string;
  description?: string;
  url?: string;
  highlight?: boolean;
  isOpen: boolean;
  idUsuario: number;
  createdAt: Date;
}

@Injectable({ providedIn: 'root' })
export class NotificationsApiService {
  private readonly http = inject(HttpClient);
  private readonly baseUrl = `${environment.apiUrl}/alert`;

  create(data: {
    title: string;
    type: string;
    description?: string;
    url?: string;
    highlight?: boolean;
    userId: string;
  }): Observable<NotificationModel> {
    return this.http.post<NotificationModel>(this.baseUrl, data);
  }

  findAll(page = 1, limit = 20): Observable<HttpResponse<AlertNotification[]>> {
    return this.http.get<AlertNotification[]>(`${this.baseUrl}/find-by-email-java`, {
      observe: 'response',
      params: { page, limit, domains: NOTIFICATION_DOMAINS.join(',') },
      context: new HttpContext().set(SKIP_HTTP_CACHE, true),
    });
  }

  markRead(alertId: string): Observable<NotificationModel> {
    return this.http.get<NotificationModel>(`${this.baseUrl}/${alertId}`, {
      context: new HttpContext().set(SKIP_HTTP_CACHE, true),
    });
  }

  markReadAll(): Observable<NotificationModel> {
    return this.http.get<NotificationModel>(`${this.baseUrl}/mark-read-all`, {
      params: { domains: NOTIFICATION_DOMAINS.join(',') },
      context: new HttpContext().set(SKIP_HTTP_CACHE, true),
    });
  }
}
